import { type PartialPropsOf } from '@blaze-runtime/engine-domain';
import {
  ITEMS_CONTAINER_ACTION_VIEW,
  type RowClickActions,
  type TableColumnFormat,
} from '@blaze-shared/elements-domain';
import { findColumn } from '@blaze-shared/schema-domain';
import { deepClone } from '@blaze-shared/shared-util';

import { migrateUnifiedRowActionsMutably } from '../../../services/compat/migration.helpers';
import { type PropsMigration } from '../../../services/compat/migrations/layout-migration.models';

export const listV2Migration: PropsMigration = {
  mode: 'props',
  description:
    'Migrate list to add row click action based on item view configuration and display format for custom fields',
  run: (props: PartialPropsOf<'list'>): void => {
    const listProps = props;
    if (!listProps) {
      return;
    }
    const { columns, customFields } = listProps?.content || {};
    // display formats
    if (listProps?.content?.customFields && customFields) {
      listProps.content.customFields = customFields.map((field) => {
        const column = findColumn(columns, field.column);
        let displayFormat: TableColumnFormat | undefined = field.displayFormat;
        /* @typescript-eslint/no-deprecated */
        if (field.format && !field.displayFormat && column) {
          displayFormat = column.format;
        }
        return {
          ...field,
          displayFormat,
        };
      });
    }

    if (listProps?.content?.itemView?.enabled) {
      const currentViewAction = deepClone(listProps.content.itemView);
      listProps.content.itemView.enabled = false;
      listProps.content.rowClick = {
        enabled: true,
        action: ITEMS_CONTAINER_ACTION_VIEW as RowClickActions,
        targetId: { [ITEMS_CONTAINER_ACTION_VIEW]: currentViewAction },
      };
    }

    migrateUnifiedRowActionsMutably(listProps);
  },
};
